import { RegionScope } from "~/hooks/useScope";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Home as HomeIcon } from "@mui/icons-material";
import { PoliciesAddDetailPage } from "~/pages/shared/policy/PoliciesAddDetailPage";

export type PoliciesAddDetailPageProps = {
  scope: RegionScope;
};

export function PlatformPoliciesAddDetailPage({
  scope,
}: PoliciesAddDetailPageProps) {
  return (
    <PoliciesAddDetailPage
      scope={scope}
      basePath="/policies"
      sectionLabel="Policies"
      renderBreadcrumbs={(policyName) => (
        <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
          <Link
            key="/dashboard"
            component={RouterLink}
            to={`/dashboard`}
            display="flex"
          >
            <HomeIcon fontSize="inherit" />
          </Link>
          <Link key="/policies" component={RouterLink} to={`/policies`}>
            Platform Policies
          </Link>
          <Link key="/policies/add" component={RouterLink} to={`/policies/add`}>
            Add Policies
          </Link>
          <Typography key="/policies/add/policyId">{policyName}</Typography>
        </Breadcrumbs>
      )}
    />
  );
}
